var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blur-card",style:({
    width: _vm.width + 'px',
    height: _vm.height + 'px',
    top: _vm.top + 'px',
    left: _vm.left + 'px',
  })})
}
var staticRenderFns = []

export { render, staticRenderFns }